<ion-card>
    <ion-card-header color="clickker-purple">
        <ion-card-title>{{title}}</ion-card-title>
    </ion-card-header>
    <ion-card-content class="logListContent">

        @if (!loading) {
            @if (errors.length > 0) {
                <mat-table [dataSource]="errors">
                    <ng-container matColumnDef="tenantName">
                        <mat-header-cell *matHeaderCellDef>{{ "components.dashboard.logList.columns.tenant" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let error"> {{error.tenant.name}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="tenantApplicationName">
                        <mat-header-cell *matHeaderCellDef>{{ "components.dashboard.logList.columns.application" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let error"> {{error.fullApplicationName}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="contentSummary">
                        <mat-header-cell *matHeaderCellDef>{{ "components.dashboard.logList.columns.content" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let error"> {{error.getSummarizedContent(lengthErrorSummary)}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="mostRecentOccurred">
                        <mat-header-cell *matHeaderCellDef>{{ "components.dashboard.logList.columns.lastOccurred" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let error">
                            <ion-icon name="time-outline" class="timeOutlineIcon"></ion-icon>
                            {{error.mostRecentOccurredAsString}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="occurrenceCount">
                        <mat-header-cell *matHeaderCellDef>{{ "components.dashboard.logList.columns.occurred" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let error">
                            <ion-chip color="{{error.errorPriority == 'error' ? 'danger' : (error.errorPriority == 'information' ? 'primary' : 'warning') }}">
                                {{error.occurrenceCount}}x </ion-chip>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
                    <mat-row mat-ripple *matRowDef="let error; columns: columnsToDisplay;" (click)="goToLogBookDetails(error)"></mat-row>
                </mat-table>
            } @else {
                <ion-row class="ion-align-items-center ion-justify-content-center loadingContainer">
                    <span>{{"components.dashboard.logList.emptyListText" | translate }}</span>
                </ion-row>
            }
        } @else {
            <ion-row class="ion-align-items-center ion-justify-content-center loadingContainer">
                <ion-spinner></ion-spinner> <span>{{"components.dashboard.logList.loadingText" | translate }}</span>
            </ion-row>
        }

    </ion-card-content>
</ion-card>
